<div class="gridItemChildModule w-100 h-100 d-flex align-items-stretch">
    <div class="d-flex flex-column position-relative" style="flex: 1 1 0px; min-width: 0px;" [hidden]="!showGrid">
        <div class="w-75 mx-auto my-2 search-box live-search" [hidden]="!showFilter">
            <input type="search" class="form-control"
                autocomplete="off"
                [(ngModel)]="filterValue"
                (ngModelChangeDebounced)="ApplyFilter()"
                [ngModelChangeDebounceTime]="500"
                ng-trim="true"
                placeholder="Search..."
                cvLocalizedPlaceholder
                [langSection]="'Subscriptions_Management'"
                [langKey]="'Search'"
            />
            <span class="clear-input" role="button" tabindex="0"
                [hidden]="filterValue.length === 0"
                (click)="ClearFilter()">
            </span>
        </div>
        <!-- Sample ag-grid.  Remove if unneeded. -->
        <ag-grid-angular #ichartTemplateGrid *ngIf="gridOptions != null" class="ag-theme-balham flex-fill" [gridOptions]="gridOptions"></ag-grid-angular>
    </div>
    <div class="view-divider" *ngIf="showGrid && showGraph"></div>
    <div style="flex: 1 1 0px; min-width: 0px;" [hidden]="!showGraph">
        <div class="h-50" #agIChart1></div>
        <div class="h-50" #agIChart2></div>
    </div>
</div>
